// to work needs to import IMask (see package.json)
/* global IMask */
/* eslint no-undef: "error" */

$(document).ready(function () {
  inputMasks()

  updatedInputStatus()
})

const commonPhoneMaskString = '***************'

let postNumberMask
const phoneMask = []
const percentageNumberMask = []
const annualSalaryMask = []
const isMobile = Math.max(
  document.documentElement.clientWidth,
  document.body.scrollWidth,
  document.documentElement.scrollWidth,
  document.body.offsetWidth,
  document.documentElement.offsetWidth
) < 600
const norgePhoneWithMaskLength = isMobile ? 14 : 15
const commonMaskLenght = 15

function inputMasks () {
  // Search input
  $('.input-group--search').each(function () {
    const clearButton = $(this).find('.btn-clear')
    const textInput = $(this).find('input')

    // Clear text input
    clearButton.on('click', function () {
      textInput.val('').focus()
    })
  })

  // ------------------------------------------------
  // Masks
  // ------------------------------------------------

  // Phone mask
  if ($('.phone-mask').length) {
    const phoneItems = document.getElementsByClassName('phone-mask')
    Array.prototype.forEach.call(phoneItems, function (element) {
      phoneMask.push(new IMask(element, {
        mask: isMobile ? '00 00 00 00 00' : '+00 00 00 00 00',
        placeholder: {
          show: 'always'
        }
      }))
    })
  }

  // Currency mask
  if ($('.currency-mask').length) {
    const currencyItems = document.getElementsByClassName('currency-mask')
    Array.prototype.forEach.call(currencyItems, function (element) {
      const suffix = (element.dataset && element.dataset.suffix) || ''
      const mask = suffix ? `num ${suffix}` : 'num'
      let value = $(element).val() || ''
      if (typeof value === 'string') {
        value = value.replace(/\s+/g, '')
        const isNeg = value.charAt(0) === '-'
        value = value.replace(/[^0-9,.]/g, '')
        if (isNeg) {
          value = '-' + value
        }
      }
      $(element).val(value)
      const currencyMask = new IMask(element, {
        lazy: !suffix,
        mask: mask,
        blocks: {
          num: {
            mask: Number,
            thousandsSeparator: ' ',
            scale: 0,
            signed: true
          }
        }
      })
    })
  }

  // Member number mask
  if ($('.member-number-mask').length) {
    const memberNumberItems = document.getElementsByClassName('member-number-mask')
    Array.prototype.forEach.call(memberNumberItems, function (element) {
      const memberNumberMask = new IMask(element, {
        mask: '00000000',
        placeholder: {
          show: 'always'
        }
      })
    })
  }

  // Post number mask
  if ($('.post-number-mask').length) {
    const postNumberItems = document.getElementsByClassName('post-number-mask')
    Array.prototype.forEach.call(postNumberItems, function (element) {
      postNumberMask = new IMask(element, {
        mask: '0000',
        placeholder: {
          show: 'always'
        }
      })
    })
  }

  // no mask
  if ($('.no-mask--phone').length) {
    const noMaskItems = document.getElementsByClassName('no-mask--phone')
    Array.prototype.forEach.call(noMaskItems, function (element) {
      const noMask = new IMask(element, {
        mask: commonPhoneMaskString,
        placeholder: {
          show: 'always'
        }
      })
    })
  }

  // birth number mask
  if ($('.birth-number-mask').length) {
    const birthNumberItems = document.getElementsByClassName('birth-number-mask')
    Array.prototype.forEach.call(birthNumberItems, function (element) {
      const birthNumberMask = new IMask(element, {
        mask: '00000000000',
        placeholder: {
          show: 'always'
        }
      })
    })
  }

  // percentage number mask
  if ($('.percentage-number-mask').length) {
    const percentageNumberItems = document.getElementsByClassName('percentage-number-mask')
    $('.percentage-number-mask').on('change', function () {
      const value = $(this).val()
      if (value !== '') {
        if (value > 100) {
          $(this).val(100)
        }

        if (value < 0) {
          $(this).val(0)
        }
      }
    })
    Array.prototype.forEach.call(percentageNumberItems, function (element) {
      percentageNumberMask.push(new IMask(element, {
        mask: '000',
        placeholder: {
          show: 'always',
          min: 0,
          max: 100
        }
      }))
    })
  }

  // annual salary number mask
  if ($('.annual-salary-number-mask').length) {
    const annualSalaryNumberItems = document.getElementsByClassName('annual-salary-number-mask')
    Array.prototype.forEach.call(annualSalaryNumberItems, function (element) {
      annualSalaryMask.push(new IMask(element, {
        mask: '000000000000000000000000000000000',
        placeholder: {
          show: 'always'
        }
      }))
    })
  }

  // exam-year-number-mask
  if ($('.exam-year-number-mask').length) {
    const examYearNumberItems = document.getElementsByClassName('exam-year-number-mask')
    const yearNow = new Date().getFullYear()
    $('.exam-year-number-mask').on('change', function () {
      const value = $(this).val()
      if (!value && !$(this).hasClass('required')) return

      if (value > yearNow) {
        $(this).val(yearNow)
      }

      if (value < 1900) {
        $(this).val(1900)
      }
    })
    Array.prototype.forEach.call(examYearNumberItems, function (element) {
      const yearNumberMask = new IMask(element, {
        mask: '0000',
        placeholder: {
          show: 'always'
        }
      })
    })
  }
}

$('.no-mask--phone').keydown(noPhoneMask)

function noPhoneMask (event) {
  return phoneInputFilter(event, $(this))
}

function phoneInputFilter (event, element) {
  const key = event.key
  const charCode = (event.which) ? event.which : event.keyCode
  const numberRegex = /[0-9]/
  const specialCharRegex = /\-|\s/
  const val = element.val()

  let inputTest

  if (val.length === 0) {
    inputTest = numberRegex.test(key) || key === '+'
  } else {
    inputTest = numberRegex.test(key) || (specialCharRegex.test(key) && !specialCharRegex.test(val.slice(-1)) && val.slice(-1) !== '+')
  }
  return inputTest || !(charCode > 31 && (charCode < 48 || charCode > 57))
}

function validOperation (inputId) {
  $(`#${inputId}`).find('.cell--input, .cell--select').removeClass('cell--error')
  $(`#${inputId}`).find('.cell--action').addClass('active')
  $(`#${inputId}`).find('.icon').removeClass('icon--exclamation-32-red')
  $(`#${inputId}`).find('.icon').addClass('icon--check-24-green')
}

function invalidOperation (inputId) {
  $(`#${inputId}`).find('.cell--input, .cell--select').addClass('cell--error')
  $(`#${inputId}`).find('.cell--action').addClass('active')
  $(`#${inputId}`).find('.icon').addClass('icon--exclamation-32-red')
  $(`#${inputId}`).find('.icon').removeClass('icon--check-24-green')
}

function resetFieldValidation (inputId) {
  $(`#${inputId}`).find('.cell--input').removeClass('cell--error')
  $(`#${inputId}`).find('.cell--action').removeClass('active')
  $(`#${inputId}`).find('.icon').removeClass('icon--exclamation-32-red')
  $(`#${inputId}`).find('.icon').removeClass('icon--check-24-green')
}

/**
 * Validates phone input. For phone-mask inputs uses masked length rules.
 * For non-masked inputs accepts 8-digit subscriber (47994539), 10-digit with country code (4747994539), or +47 format.
 * @param {string} input - The phone value
 * @param {boolean} hasPhoneMask - Whether the input has the phone-mask class
 * @returns {boolean}
 */
function isPhoneValid (input, hasPhoneMask) {
  if (!input) return false
  const telephoneIsNorge = input.startsWith('47') || input.startsWith('+47')
  if (hasPhoneMask) {
    if (telephoneIsNorge && input.length === norgePhoneWithMaskLength) return true
    if (!telephoneIsNorge && input.length <= commonMaskLenght) return true
    return false
  }
  if (telephoneIsNorge) {
    const digits = input.replace(/\D/g, '')
    return (digits.length === 8 && digits.startsWith('47')) || digits.length === 10
  }
  return input.length <= commonMaskLenght
}

function updatedInputStatus () {
  $('form .form-table__row input').on('change', function () {
    const inputId = $(this).closest('.form-table__row').attr('id')

    const input = $(this).val()
    const required = $(this).hasClass('required')

    if (input === '' && required) {
      invalidOperation(inputId)
    } else {
      if (inputId && (inputId.includes('email') || inputId.search(/email/gmi) !== -1)) {
        const validEmail = validateEmail(input)
        if (validEmail) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid email')
        }
      } else if (inputId && inputId.includes('phone')) {
        const hasPhoneMask = $(this).hasClass('phone-mask')
        if (isPhoneValid(input, hasPhoneMask)) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
        }
      } else if (inputId && inputId.includes('birth-number')) {
        const checkBirthNumber = fnr(input)
        if (input && input.length && checkBirthNumber.status === 'valid') {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid birth-number')
        }
      } else if (inputId && inputId === 'recruiter') {
        if (input && input.length && input.length == 8) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid recruit-number')
        }
      } else {
        validOperation(inputId)
      }
    }

    if (input === '' && !required) {
      validOperation(inputId)
    }
  })
}

/**
 * check if all form fields are filled in correctly
 * @param {*} formData data filled in the form
 * @returns {Boolean} true if there is an error
 */
function checkFormFields (formData) {  // eslint-disable-line
  if (!formData) {
    return true
  }

  let invalidFields = false

  // const formInputs = $('form .form-table__row')

  const formRequiredInputIds = []
  $('form .form-table__row:visible').each(function () { $(this).find('.required').length ? formRequiredInputIds.push($(this).attr('id')) : undefined })

  formRequiredInputIds.forEach(inputId => {
    if (!formData.has(inputId)) return

    const input = formData.get(inputId)

    if (input === '') {
      invalidOperation(inputId)
      invalidFields = true
    } else {
      if (inputId && (inputId.includes('email') || inputId.search(/email/gmi) !== -1)) {
        const validEmail = validateEmail(input)
        if (validEmail) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid email')
          invalidFields = true
        }
      } else if (inputId.includes('phone')) {
        const inputElement = $(`#${inputId}`).find('input')[0]
        const hasPhoneMask = inputElement ? $(inputElement).hasClass('phone-mask') : false
        if (isPhoneValid(input, hasPhoneMask)) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          invalidFields = true
        }
      } else if (inputId && inputId.includes('birth-number')) {
        const checkBirthNumber = fnr(input)
        if (input && input.length && checkBirthNumber.status === 'valid') {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid birth-number')
          invalidFields = true
        }
      } else {
        validOperation(inputId)
      }
    }
  })

  const formNotRequiredInputIds = []
  $('form .form-table__row:visible').each(function () { !$(this).find('.required').length ? formNotRequiredInputIds.push($(this).attr('id')) : undefined })

  formNotRequiredInputIds.forEach(inputId => {
    if (!formData.has(inputId)) return

    const input = formData.get(inputId)

    if (input !== '') {
      invalidOperation(inputId)
      if (inputId && (inputId.includes('email') || inputId.search(/email/gmi) !== -1)) {
        const validEmail = validateEmail(input)
        if (validEmail) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid email')
          invalidFields = true
        }
      } else if (inputId.includes('phone')) {
        const inputElement = $(`#${inputId}`).find('input')[0]
        const hasPhoneMask = inputElement ? $(inputElement).hasClass('phone-mask') : false
        if (isPhoneValid(input, hasPhoneMask)) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          invalidFields = true
        }
      } else if (inputId && inputId.includes('birth-number')) {
        const checkBirthNumber = fnr(input)
        if (input && input.length && checkBirthNumber.status === 'valid') {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid birth-number')
          invalidFields = true
        }
      } else if (inputId && inputId === 'recruiter') {
        if (input && input.length && input.length == 8) {
          validOperation(inputId)
        } else {
          invalidOperation(inputId)
          // $(`#${inputId}`).find('.error-message').text('invalid recruit-number')
          invalidFields = true
        }
      } else {
        validOperation(inputId)
      }
    } else {

    }
  })

  return invalidFields
}

/**
 * check if the format of an email is valid
 * @param {String} email
 * @returns {Boolean}
 */
function validateEmail (email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ //eslint-disable-line
  return re.test(String(email).toLowerCase())
}

// FNR VALIDATOR
const elevenDigits = new RegExp('^\\d{11}$')

const fnr = (digits) => {
  return idnr(digits)
}

const dnr = (digits) => {
  return idnr(digits)
}

const idnr = (digits) => {
  const isDnr = digits.substring(0, 1) >= 4
  return validate(digits, isDnr)
}

const validate = (digits, isDnr) => {
  if (!elevenDigits.test(digits)) {
    return {
      status: 'invalid',
      reasons: ['fnr or dnr must consist of 11 digits']
    }
  }

  if (digits == '00000000000') {
    return {
      status: 'valid',
      type: 'test fnr'
    }
  }

  const errMsgs = [...checksums(digits), ...birthdate(digits, isDnr)]

  return errMsgs.length == 0 ? { status: 'valid', type: isDnr ? 'dnr' : 'fnr' } // eslint-disable-line
    : {
      status: 'invalid',
      reasons: errMsgs
    }
}

const checksums = (digits) => {
  let k1 = 11 - ((3 * digits[0] + 7 * digits[1] + 6 * digits[2] + 1 * digits[3] + 8 * digits[4] +
      9 * digits[5] + 4 * digits[6] + 5 * digits[7] + 2 * digits[8]) % 11)
  let k2 = 11 - ((5 * digits[0] + 4 * digits[1] + 3 * digits[2] + 2 * digits[3] + 7 *
      digits[4] + 6 * digits[5] + 5 * digits[6] + 4 * digits[7] + 3 * digits[8] + 2 * k1) % 11)

  if (k1 === 11) k1 = 0
  if (k2 === 11) k2 = 0

  return k1 < 10 && k2 < 10 && k1 == digits[9] && k2 == digits[10] // eslint-disable-line
    ? [] : ["checksums don't match"]
}

// copied from https://stackoverflow.com/questions/5812220/how-to-validate-a-date
const birthdate = (digits, isDnr) => {
  if (isDnr) {
    digits = (digits.substring(0, 1) - 4) + digits.substring(1)
  }

  const day = digits.substring(0, 2)
  const month = digits.substring(2, 4)
  const year = digits.substring(4, 6)

  // set year 00 default to 2000 instead of 1900
  const date = new Date(year === '00' ? '2000' : year, month - 1, day)

  return (date && (date.getMonth() + 1) == month && date.getDate() == day) // eslint-disable-line
    ? [] : ['invalid date']
}

/**
 * Cleans the validation status of all fields
 * @param {*} formData
 */
function cleanValidation (formData) { // eslint-disable-line
  if (formData) {
    const formRequiredInputIds = []
    $('form .form-table__row').each(function () { $(this).length ? formRequiredInputIds.push($(this).attr('id')) : undefined }) // eslint-disable-line

    formRequiredInputIds.forEach(inputId => {
      resetFieldValidation(inputId)
    })
  }
}
